import { InjectionToken } from '@angular/core';

/**
 * Whether `SeasonManagerService` persists the selected season year across
 * reloads (per tenant, in `localStorage`).
 *
 * **Default: `false`** — any app that does not opt in keeps the historical
 * in-memory behaviour, where the selection resets on every boot.
 *
 * Only the admin panel opts in. In the admin the season year is an explicit,
 * always-visible topbar filter, so losing it on F5 is a bug. In the mobile app
 * (`apps/app`) `season$` is not a screen filter: it drives "Mis partidos",
 * "Mis rankings" and favourites, and the only place the user can change it is a
 * dropdown buried in the Rankings tab. Persisting it there would leave the app
 * permanently opened on a past season with an empty home and no favourites,
 * with no hint of why — today that state heals itself on restart.
 *
 * @example — admin/src/app/app.config.ts
 * ```ts
 * { provide: SEASON_PERSISTENCE_ENABLED, useValue: true }
 * ```
 */
export const SEASON_PERSISTENCE_ENABLED = new InjectionToken<boolean>('SEASON_PERSISTENCE_ENABLED', {
  providedIn: 'root',
  factory: () => false,
});
